import '../../stylus/components/_grid.styl'

import Grid from './grid'

export default Grid('container')
